// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"04e3ecaa","890":"04e3ecaa"}[chunkId] + ".chunk.css";
};